<template>
  <div class= "yhHouseManageList">
    <div class="filters">
      <el-form :inline="true">
        <el-form-item>
          <el-input placeholder="请输入楼层" v-model="gardenGridsName1">
          </el-input>
        </el-form-item>
        <el-button type="primary" @click="commit">查询</el-button>
      </el-form>
    </div>
    <el-card>
      <el-button type="primary" slot="header" @click="add" >新增</el-button>  
      <el-table :data="tableData" class="wid100" :row-class-name="tableRowClassName" :height="tableData.length > 0 ? require('@/config/enum').tableheight529 : require('@/config/enum').tableheight109">
        <el-table-column type="index" :index="indexMethod" align="center" :label="$t('lang.lab_index')" width="100px"></el-table-column>
        <el-table-column prop="name" label='名称'></el-table-column>
        <el-table-column prop="info" label='标签'></el-table-column>
        <el-table-column prop="operate" :label="$t('lang.lab_operation')" :width="require('@/config/enum').opr_width2">
          <template slot-scope="scope">
            <el-button @click="edit(scope.row)">修改</el-button>
            <el-button class="orange" @click="deleteOne(scope.row)" >删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pageNo"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="pageSize"
        layout="sizes, prev, pager, next, jumper"
        :page-count="pageCount"
      />
    </el-card>
    <el-dialog :title=title :visible.sync="isPopupPage" :close-on-click-modal="false"
      center
      top="130px"
      width="600px"
      @closed="handleDialogClosed">
      <el-form :model="form" :rules="rules" ref="form" :label-width="require('@/config/enum').c_ws2" :label-suffix="require('@/config/enum').c_colon">
        <el-form-item label="楼层名称" prop="name" class="item-input">
          <el-input v-model="form.name" placeholder="请输入楼层（例：1F,2F,B1,B2）" maxlength="20"></el-input>
        </el-form-item>
        <el-form-item label="楼层标签" prop="info" class="item-input">
          <el-input v-model="form.info" placeholder="请输入楼层标签（例：国际精品）" maxlength="4"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="resetForm">{{$t('lang.btn_rest')}}</el-button>
        <el-button type="primary" @click="save('form')" :disabled="isDisabled">{{$t('lang.btn_save')}}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  data() {
    // 表格内容默认数据
    return {
      isDisabled: true, // 保存的可点击
      isPopupPage: false, // 弹框的显示控制
      isAdd: false, // 标识新增(true)或编辑(false)
      parentId: '', // 上一级id
      editId: '', // 正在编辑的ID
      title: '新增楼层', // 弹窗标题
      pageCount: 0, // 总页数
      pageNo: 1, // 页数
      pageSize: 10, // 每页显示数量
      tableData: [], // 列表数据
      form: {
        name: '',
        info: '',
      },
      rules: {
        name: [{ 
          required: true, 
          message: '请输入楼层', 
          trigger: 'blur' 
        }],
        info: [{ 
          required: true, 
          message: '请输入楼层标签', 
          trigger: 'blur' 
        }],      
      },
      gardenGridsName1: '', // 楼号搜索框
    }
  },
  created() {
    this.parentId = this.gardenId
    this.getData()
  },
  computed: {
    ...mapGetters(['gardenId', 'userGardenList'])
  },
  watch: {
    gardenId: function (newVal, oldVal) {
      this.parentId = this.gardenId
      this.commit()
    },
    form: {
      handler(newVal, oldVal) {
        // form数据变化时 会调用此方法
        let tempRule = JSON.stringify(newVal)
        if (tempRule === this.saveData) {
          // 没变
          this.isDisabled = true
        } else {
          // 变了
          this.isDisabled = false
        }
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    // ID序号功能
    indexMethod(index) {
      return (this.pageNo - 1) * this.pageSize + index + 1
    },
    // 列表斑马线
    tableRowClassName({ row, rowIndex }) {
      return rowIndex % 2 === 0 ? 'row-dark' : ''
    },
    // 翻页
    handleCurrentChange(val) {
      this.pageNo = val
      this.getData()
    },
    // 切换每页显示多少数据
    handleSizeChange(val) {
      this.pageNo = 1
      this.pageSize = val
      this.getData()
    },
    // 获取楼层列表
    getData() {
      let loading = this.$loading()
      this.$get(`/gardenGrids?gardenGridsName=${this.gardenGridsName1}&type=1&isShop=1&parentId=${this.parentId}&pageNo=${this.pageNo}&pageSize=${this.pageSize}`).then(
        res => {
          loading.close()
          if (res && res.errCode === 0) {
            this.tableData = res.list
            this.pageCount = res.pageCount
          }
        },
        error => {
          loading.close()
          this.$message.error(error)
        }
      )   
    },
    // 更新
    commit() {
      this.pageNo = 1
      this.getData()
    },
    // 添加
    add() {
      this.isPopupPage = true
      this.isAdd = true
      this.title = '新增楼层'
    },
    // 编辑
    edit(rowData) {
      this.title = '修改楼层'
      this.editId = rowData.id
      this.form.name = rowData.name
      this.form.info = rowData.info
      this.isPopupPage = true
      this.isAdd = false
      this.saveData = JSON.stringify(this.form)
    },
    // 删除
    deleteOne(row) {
      let loading = this.$loading()
        this.$confirm(
            this.$i18n.t('lang.lab_isdelete'),
            this.$i18n.t('lang.lab_prompt'), {
              confirmButtonText: this.$i18n.t('lang.btn_confirm'),
              cancelButtonText: this.$i18n.t('lang.btn_cancel'),
              type: 'warning'
            }
          )
          .then(() => {
            let params = {
              idArr: row.id
            }
            this.$delete(`/gardenGrids/delByBatch`, params).then(
                res => {
                  loading.close()
                  console.log(res)
                  if (res && res.errCode === 0) {
                    this.$message.success('删除成功')
                    this.commit()
                  }
                },
                error => {
                  console.log(error)
                  loading.close()
                  this.$message.error(error)
                }
              )
          })
          .catch(() => {
            loading.close()
            this.$message({
              type: 'info',
              message: this.$i18n.t('lang.lab_del_can')
            })
          })
    },
    // 保存
    save(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          if (this.isAdd) {
            let params = {
              type: 1,
              parentId: this.parentId,
              name: this.form.name,
              info: this.form.info,
              isShop: 1,
            }
            let loading = this.$loading()
            this.$post(`/gardenGrids`, params).then(
              res => {
                loading.close()
                if (res && res.errCode === 0) {
                  this.$message.success(this.$i18n.t('lang.lab_save_success'))
                  this.isPopupPage = false
                  this.commit()
                }
              },
              error => {
                loading.close()
                this.$message.error(error)
              }
            )
          } else {
            let loading = this.$loading()
            let params = {
              id: this.editId,
              type: 1,
              parentId: this.parentId,
              name: this.form.name,
              info: this.form.info,
              isShop: 1,
            }
            this.$patch(`/gardenGrids/${this.editId}`, params).then(
              res => {
                loading.close()
                if (res && res.errCode === 0) {
                  this.$message.success(this.$i18n.t('lang.lab_save_success'))
                  this.isPopupPage = false
                  this.commit()
                }
              },
              error => {
                loading.close()
                this.$message.error(error)
                this.isPopupPage = false
              }
            )
          } 
        }
      })
    },
    // 清空
    resetForm() {
      this.$refs.form.clearValidate()
      this.form.name = ''
      this.form.info = ''
    },
    // 监听关闭dialog
    handleDialogClosed() {   
      this.resetForm()
    },
  }
}
</script>

<style lang= 'scss'>
.yhHouseManageList{
  .item-input{
    width: 90%;
  }
  .el-table .DisableSelection .cell .el-checkbox__inner{
          display: none;
          position: relative;
        }
  .el-table .DisableSelection .cell:before{
          content: "";
          position: absolute;
  }
  .card-header {
    display: flex;
    align-items: center;

    .path-tag {
      margin-left: 20px;
      padding: 0 15px;
    }
  }
}
 .yhHouseManageList .upload-demo {
    display: inline;
    padding-left: 20px;
  }
</style>